import { create } from "zustand";

/** Tenant / app feature toggles synced from TM descriptionJson.feature_flags */
export interface GlobalFeatureFlags {
  /** Dynamic feature flags from `/tm/feature-flags` API (moduleId=7). */
  [key: string]: boolean | undefined;
  enableServerPagination: boolean;
  enableEsign: boolean;
  enableControlledLifecycleValidation?: boolean;
}

const defaultFlags: GlobalFeatureFlags = {
  enableServerPagination: true,
  enableEsign: true,
};

type GlobalFeatureFlagStore = {
  flags: GlobalFeatureFlags;
  /** Merge partial flags (e.g. after tenant config loads). */
  setGlobalFeatureFlags: (partial: Partial<GlobalFeatureFlags>) => void;
  resetGlobalFeatureFlags: () => void;
};

const useGlobalFeatureFlagStore = create<GlobalFeatureFlagStore>((set) => ({
  flags: { ...defaultFlags },
  setGlobalFeatureFlags: (partial) =>
    set((state) => ({
      flags: { ...state.flags, ...partial },
    })),
  resetGlobalFeatureFlags: () => set({ flags: { ...defaultFlags } }),
}));

export default useGlobalFeatureFlagStore;
